import type { FC } from 'react';

import { useAuth } from '@nodal/api/auth';
import { useEffect } from 'react';
import { useNavigate, matchPath } from 'react-router-dom';

import { paths } from 'consts/paths';

// NOTE:
// A user whose tokens turned out to be expired / invalid while being in the
// protected app has to be sent to the logout page, which clears the tokens
// and redirects to the sign-in page. Unauthenticated pages (sign-in,
// sign-up, forgot / reset password, authenticate) are intentionally left
// alone, e.g. a failed sign-in attempt must not bounce the user through the
// logout page.
export const logout = () => {
  if (matchPath(`${paths.app}/*`, window.location.pathname)) {
    window.location.href = paths.logout;
  }
};

export const Logout: FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(paths.signin);
    auth.tokenProvider.removeTokens();
    console.log('[@nodal/core/flows/Logout] removeTokens');
  }, [navigate, auth]);

  return <></>;
};
